import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import QueuePlanner from "./pages/QueuePlanner";
import QueueListPage from "./pages/QueueListPage";
import OfferRedirect from "./pages/OfferRedirect";
import MassBroadcast from "./pages/MassBroadcast";
import LinkPublisherPage from "./pages/LinkPublisherPage";
import GroupMembersPage from "./pages/GroupMembersPage";
import VitrineHoje from "./pages/VitrineHoje";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<QueuePlanner />} />
        <Route path="/fila" element={<QueueListPage />} />
        <Route path="/oferta/:id" element={<OfferRedirect />} />
        <Route path="/grupo-vip" element={<MassBroadcast />} />
        <Route path="/lista" element={<LinkPublisherPage />} />
        <Route path="/grupos" element={<GroupMembersPage />} />
        <Route path="/hoje" element={<VitrineHoje />} />
      </Routes>
    </BrowserRouter>
  );
}